import React from 'react';
import styled from 'styled-components';
import SignUpLockSmallSvg from '../../stories/assets/SignUpLockSmall.svg';

const SignUpLockSmall = styled(SignUpLockSmallSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || '1.5rem'};
  cursor: pointer;
`;

export default SignUpLockSmall;
